import React, {memo, useContext, useEffect, useRef, useState} from 'react';

import "./note_edge_connection_node.scss";
import {WorkflowCanvasContext} from "../../contexts/WorkflowCanvasContextProvider";

const NoteEdgeConnectionNode = ({id, data}) => {

    const [showToolbar, setShowToolbar] = useState(false);
    const contextMenuRef = useRef(null);
    const workflowContext = useContext(WorkflowCanvasContext);


    useEffect(() => {
        // Add event listener when the component is mounted
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Clean up event listener when the component is unmounted
            document.removeEventListener("click", handleClickOutside);
            document.addEventListener("mousedown", handleClickOutside);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickOutside = (event) => {
        if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
            setShowToolbar(false);
        }
    };

    const handleToolbarClick = (e) => {
        e.preventDefault();
        setShowToolbar(true);
    }

    const handleDelete = () => {
        const updatedData = workflowContext.nodes.filter(item => item.id !== id);
        workflowContext.setEdges(eds => eds.filter((edge) => edge.source !== id && edge.target !== id));

        workflowContext.setNodes(updatedData)
        
        // Trigger save after deletion
        if (workflowContext.autoSaveEnabled) {
            setTimeout(() => {
                workflowContext.saveWorkflow(true);
            }, 100);
        }
        setShowToolbar(false);

    }

    return (
        <div
            style={{position: "relative"}}
            className="note-edge-connection-node"
            onContextMenu={(e)=> handleToolbarClick(e)}
        >
            <div className="note-edge-connection-line"/>
            {showToolbar &&
                <div
                    ref={contextMenuRef}
                    className="absolute left-5 top-2.5 z-20 overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-lg"
                >
                    <button
                        type="button"
                        onClick={() => handleDelete(data.id)}
                        className="flex w-full items-center gap-2 whitespace-nowrap px-4 py-2 text-left text-sm font-medium text-red-600
                            transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/30"
                    >
                        Delete
                    </button>
                </div>}
        </div>

    );
};

export default memo(NoteEdgeConnectionNode);